module.exports = __webpack_public_path__ + "static/img/coupon_bg_en_invalid.4b5cd113.png";